export const allHeadCells = [
  { id: 'date', numeric: false, disablePadding: true, label: 'Date', format: (value) => value ? new Date(value).toLocaleDateString() : '' },
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
  { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
];

export const importantHeadCells = [
  { id: 'date', numeric: false, disablePadding: true, label: 'Date', format: (value) => value ? new Date(value).toLocaleDateString() : '' },
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
  { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
];

export const activitiesHeadCells = [
  { id: 'date', numeric: false, disablePadding: true, label: 'Date', format: (value) => value ? new Date(value).toLocaleDateString() : '' },
  { id: 'type', numeric: false, disablePadding: false, label: 'Type' },
  { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
  { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
];

export const observationHeadCells = [
  { id: 'date', numeric: false, disablePadding: true, label: 'Date', format: (value) => value ? new Date(value).toLocaleDateString() : '' },
  { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
  { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
];

export const vitalsHeadCells = [
  { id: 'date', numeric: false, disablePadding: true, label: 'Date', format: (value) => value ? new Date(value).toLocaleDateString() : '' },
  { id: 'category', numeric: false, disablePadding: false, label: 'Category' },
  { id: 'description', numeric: false, disablePadding: false, label: 'Description' },
];

function createData(id, date, type, category, description) {
  return { id, date, type, category, description };
}
